<script>
  import { impression, trackEvent } from '../util/snowplow';
  import BigPromo from './BigPromo.svelte';

  export let big = false;
  const url =
    'https://www.nrk.no/anmeldelser/anmeldelse_-melodi-grand-prix-2024-_-fremforingene-i-finalen-1.16741843';
  const campaign = `?utm_source=delta&utm_medium=promo_no_image&utm_campaign=mgp`;
</script>

{#if big}
  <BigPromo />
{:else}
  <a
    class="further-navigation"
    href={url + campaign}
    target="_blank"
    on:click={() => trackEvent({ action: 'click:further-navigation-no-image' })}
    use:impression={'promo:no-image'}
    >Er du enig med anmelderne? <br />
    <span> Les anmeldelsen på nrk.no </span></a
  >
{/if}

<style>
  .further-navigation {
    text-align: center;
    margin-top: 4rem;
  }

  .further-navigation > span {
    text-decoration: underline;
  }
</style>
